module.exports = __webpack_public_path__ + "img/8.97dec838.webp";